import { jsx as _jsx } from "react/jsx-runtime";
import { t } from "i18next";
import { mapAirlineIataToName } from "@mappings";
import SvgDy from "./Dy";
import SvgN0 from "./N0";
import SvgSk from "./Sk";
import SvgWf from "./Wf";
import SvgYY from "./Yy";
const iconMappings = {
    DY: SvgDy,
    D8: SvgDy,
    SK: SvgSk,
    WF: SvgWf,
    N0: SvgN0,
};
const AirlineIcon = ({ airline, height = "1.5rem", width = "1.5rem", shape }) => {
    const IconComponent = airline && iconMappings[airline] ? iconMappings[airline] : SvgYY;
    return shape == "circle" ? (_jsx("div", { style: { borderRadius: "9999px", border: "0.6px solid var(--ds-color-neutral-border-default)", display: "flex", overflow: "hidden" }, children: _jsx(IconComponent, { title: mapAirlineIataToName(airline, () => {
                return t(airline === "remaining" ? "others" : airline);
            }, {
                targetAirline: "Norse Atlantic Airways",
                modifyOutput: (name) => {
                    return name.split(" ")[0];
                },
            }), height: height, width: width }) })) : (_jsx(IconComponent, { title: airline, height: height, width: width }));
};
export default AirlineIcon;
